<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>
        <v-form name="sandboxForm">
            <Dialog modal
                    :visible="isPackDbAndSendFormOpen"
                    v-model:visible="isPackDbAndSendFormOpen"
                    :header="__('Connection parameters')"
                    :style="{ width: '850px' }">
                <PackDbAndSendForm v-model:isPackDbAndSendFormOpen="isPackDbAndSendFormOpen">
                </PackDbAndSendForm>
            </Dialog>

            <ConfirmDialog header="Confirm operation"
                           question="Do you want to run sandbox code?"
                           v-model="isConfirmationOpen"
                           :operation="runSandboxCode" />

            <div class="grid justify-content-between"
                 style="margin-top:30px">
                <Button @click.stop="openConfirmationWindow()"
                        style="background-color:cadetblue;margin:0 7px 0 25px"
                        severity="info">
                    <i class="fa-solid fa-unlock-keyhole"
                       style="margin-right:5px;font-size:18px"></i>{{ __('Run sandbox code') }}</Button>

                <Button @click.stop="openPackDbAndSendForm()"
                        style="background-color:royalblue;margin:0 7px 0 25px"
                        severity="info">
                    <i class="fa-solid fa-database"
                       style="margin-right:5px;font-size:18px"></i></Button>

            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ConfirmDialog from '@pages/Crud/ConfirmDialog.vue'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import PackDbAndSendForm from './PackDbAndSendForm.vue'
import { __, getFromRoute, screenMessage, getTimeouts } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isConfirmationOpen = ref(false)
const isPackDbAndSendFormOpen = ref(false)
const isLoading = ref(false);

// -----------------------------------------------------

onMounted(async () => {

})

// -----------------------------------------------------

const openConfirmationWindow = () => {
    isConfirmationOpen.value = true
}

// -----------------------------------------------------

const openPackDbAndSendForm = () => {
    isPackDbAndSendFormOpen.value = true
}

// -----------------------------------------------------

const runSandboxCode = async () => {
    try {
        isLoading.value = true
        const returnData = await getFromRoute('sandbox-run', {})
        isLoading.value = false

        console.log(returnData)
    } catch (e) {
        console.err(e)
    }

    const timeouts = getTimeouts()
    screenMessage({ message: __('Sandbox code was executed'), title: "Information", type: "info", position: "center", timeout: timeouts.info });
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
